import { STOP_SYNC } from './actionTypes'

export const setStopSync = () => ({
  type: STOP_SYNC,
})
